import React, { useState, useEffect } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  FlatList,
  TextInput,
} from "react-native";
import Modal from "modal-react-native-web";
import Header from "../../component/header";
import Background from "../../component/background";
import TabbarOption from "../../component/tabbarOption";
import { FontAwesome } from "@expo/vector-icons";
import { useRecoilState } from "recoil";
import { useIsFocused } from "@react-navigation/native";
import { getAllcompetitions, conditioncheck } from "../../action/authAction";
import { styles, stylesResponsive } from "./style";
import { tokenState, userState } from "../../reducer/recoil";
import { apiservice } from "../../service";
const { width, height } = Dimensions.get("window");
export default function index({ navigation }) {
  const [data, setData] = useState([]);
  const [Associationdata, AssociationsetData] = useState([]);
  const [text, setText] = useState("");
  const [caseNo, setCaseNo] = useState(3);
  const [token, setToken] = useRecoilState(tokenState);
  const [user, SetUser] = useRecoilState(userState);
  const [motype, setMotype] = useState(true);
  const focus = useIsFocused();
  const [modalVisible, setModalVisible] = useState(false);
  function onModalShow() {
    setModalVisible(true);
    setTimeout(() => {
      setModalVisible(false);
    }, 2000);
  }

  useEffect(() => {
    if (focus) {
      callFunc();
    }
  }, [focus, user, token]);

  const callFunc = async () => {
    const response = await getAllcompetitions(token.token);
    try {
      AssociationsetData(
        response.associations.filter(
          (e) => e.association_id == user.profile.Association.association_id
        )
      );
    } catch (error) {}

    const asyncRes = await Promise.all(
      response.competitions.map(async (item) => {
        const responses = await callApi({
          competition_id: item.competition_id,
        });
        try {
          return { ...item, condition: responses.length > 0 ? true : false };
        } catch (error) {
          // return { ...item, condition: responses.length > 0 ? true : false };
        }
      })
    );
    setData(asyncRes);
  };

  async function callApi({ competition_id }) {
    try {
      const acceptance = await apiservice({
        method: "get",
        path:
          "/approbations/condition-acceptance?competition_id=" +
          competition_id +
          "&association_id=" +
          user.profile.Association.association_id,
        token: token.token,
      });

      console.log("acceptance ", acceptance);

      if (acceptance.status == 200) {
        return acceptance.data.result;
      }
    } catch (error) {}
  }

  async function conditioncheckApi(item) {
    const response = await conditioncheck({
      body: {
        association_id: user.profile.Association.association_id,
        competition_id: item.competition_id,
      },
      token: token.token,
    });

    if (response) {
      if (response.result == true) {
        navigation.navigate("PrelimEntry", item);
      } else {
        setMotype(true);
        onModalShow();
      }
    }
  }

  console.log("state >>> ", data);

  return (
    <View style={styles.container}>
      <Modal
        animationType="fade"
        transparent={true}
        visible={modalVisible}
        onRequestClose={() => {
          // Alert.alert("Modal has been closed.");
          setModalVisible(!modalVisible);
        }}
      >
        <View style={{ flex: 1, backgroundColor: "#000000bb" }}>
          <View style={styles.viewModal}>
            <Text style={styles.textModal}>
              {motype
                ? "YOUR COUNTRY IS NOT ALLOW TO REGISTER THIS COMPETITON \nPLEASE CONTACT AAA SERVICE"
                : "YOU SENT APPLICATION FROM WAITING FOR ADMIN APPROVE"}
            </Text>
          </View>
        </View>
      </Modal>
      <Header
        onPressHome={() => {
          navigation.navigate("HomeUser");
        }}
        onPressCompetition={() => {
          navigation.navigate("CompetitionUser");
        }}
        onPressAthlete={() => {
          navigation.navigate("AthleteUser");
        }}
        onPressLogout={() => {
          navigation.navigate("Login");
        }}
        backgroundColorCompetition="#FFFFFF"
        User
        navigation={navigation}
      />
      <ScrollView>
        <View style={{}}>
          <Background navigation={navigation} Title="COMPETITIONS" />
          <TabbarOption
            CompetitionUser
            navigation={navigation}
            onfilter={(e) => {
              setCaseNo(e);
            }}
            onChangeText={(text) => {
              setText(text);
            }}
          />
          {width >= 1280 && (
            <View style={styles.viewTopic}>
              <Text
                numberOfLines={1}
                style={[
                  styles.textSubject,
                  { textAlign: "left", maxWidth: 120, width: "100%" },
                ]}
              >
                IMAGE
              </Text>
              <Text
                numberOfLines={1}
                style={[
                  styles.textSubject,
                  {
                    width: "25%",
                    textAlign: "left",
                  },
                ]}
              >
                NAME
              </Text>
              <Text
                numberOfLines={1}
                style={[styles.textSubject, { width: "15%" }]}
              ></Text>
              <Text
                numberOfLines={1}
                style={[styles.textSubject, { width: "15%" }]}
              >
                PRELIMINARY ENTRY
              </Text>
              <Text
                numberOfLines={1}
                style={[styles.textSubject, { width: "15%" }]}
              >
                FINAL ENTRY DATE
              </Text>
              <Text numberOfLines={1} style={[styles.textSubject]}>
                STATUS
              </Text>
            </View>
          )}
          <FlatList
            data={data
              .filter((e) => {
                if (caseNo == "Active") {
                  return (
                    (e.prelim_status === "Open" &&
                      e.final_status === "Pending") ||
                    (e.prelim_status === "Closed" && e.final_status === "Open")
                  );
                } else if (caseNo == "Inactive") {
                  return (
                    !(
                      e.prelim_status === "Open" && e.final_status === "Pending"
                    ) ||
                    !(e.prelim_status === "Closed" && e.final_status === "Open")
                  );
                } else {
                  return e;
                }
              })
              .filter((e) => e.name.toLowerCase().includes(text.toLowerCase()))}
            scrollEnabled={width < 1280 ? true : false}
            renderItem={({ index, item }) => {
              let prelim =
                new Date(item.prelim_start_date).getTime() <=
                  new Date().getTime() &&
                new Date(item.prelim_end_date).getTime() >=
                  new Date().getTime();

              let final = false;
              try {
                Associationdata.map((items, idexs) => {
                  let itemArr = items.Approbations.filter((i) => {
                    return item.competition_id == i.competition_id;
                  })[0];
                  prelim = itemArr == undefined;
                  final =
                    new Date(item.final_start_date).getTime() <=
                      new Date().getTime() &&
                    new Date(item.final_end_date).getTime() >=
                      new Date().getTime() &&
                    itemArr.approbation_status == "Approved" &&
                    itemArr.approbation_type == "Prelim";
                  final =
                    (itemArr.approbation_status !== "Approved" &&
                      itemArr.approbation_type == "Final") ||
                    (itemArr.approbation_status !== "Pending" &&
                      itemArr.approbation_type == "Prelim");
                });
              } catch (error) {}

              return width >= 1280 ? (
                <View
                  style={[
                    styles.viewDetail,
                    {
                      backgroundColor: index % 2 == 0 ? "#CCE4FF" : "#FFFFFFbb",
                    },
                  ]}
                >
                  <Image
                    resizeMode={"contain"}
                    style={styles.imgDetail}
                    source={{ uri: item.image_url }}
                  />
                  <Text
                    numberOfLines={1}
                    style={[styles.textTitle, { width: "25%" }]}
                  >
                    {item.name}
                  </Text>
                  <View style={{ width: "15%", alignItems: "center" }}>
                    <TouchableOpacity
                      disabled={item.condition}
                      onPress={() => {
                        navigation.navigate("Condition", item);
                      }}
                      style={[
                        styles.buttomDetail,
                        {
                          backgroundColor: item.condition
                            ? "#AFAFAF"
                            : "#2B6AB1",
                        },
                      ]}
                    >
                      <Text style={styles.textButtonDetail}>CONDITION</Text>
                    </TouchableOpacity>
                  </View>
                  <View style={{ width: "15%", alignItems: "center" }}>
                    <TouchableOpacity
                      disabled={!(prelim && item.condition)}
                      onPress={() => {
                        conditioncheckApi(item);
                      }}
                      // disabled={item.prelim_status == "Pending" ? true : false}
                      style={[
                        styles.buttomDetail,
                        {
                          backgroundColor: !(prelim && item.condition)
                            ? "#AFAFAF"
                            : "#2B6AB1",
                        },
                      ]}
                    >
                      <Text style={styles.textButtonDetail}>PRELIM. FORM</Text>
                    </TouchableOpacity>
                  </View>
                  <View style={{ width: "15%", alignItems: "center" }}>
                    <TouchableOpacity
                      disabled={!final}
                      onPress={() => {
                        Associationdata.map((items, idexs) => {
                          let itemArr = items.Approbations.filter((i) => {
                            return item.competition_id == i.competition_id;
                          })[0];
                          if (
                            itemArr.approbation_status == "Pending" &&
                            itemArr.approbation_type == "Final"
                          ) {
                            setMotype(false);
                            onModalShow();
                          } else {
                            navigation.navigate("FinalEntryUser", {
                              ...item,
                              ...itemArr,
                            });
                          }
                        });
                      }}
                      style={[
                        styles.buttomDetail,
                        {
                          backgroundColor: !final ? "#AFAFAF" : "#2B6AB1",
                        },
                      ]}
                    >
                      <Text style={styles.textButtonDetail}>FINAL FORM</Text>
                    </TouchableOpacity>
                  </View>
                  <Text style={[styles.textSubject, {}]}>
                    {item.prelim_status === "Open" ||
                    item.final_status === "Open"
                      ? "active"
                      : "inactive"}
                  </Text>
                </View>
              ) : (
                <View
                  style={[
                    stylesResponsive.viewDetail,
                    {
                      backgroundColor: index % 2 == 0 ? "#CCE4FF" : "#FFFFFFbb",
                      borderTopWidth: index >= 1 ? 0 : 1,
                    },
                  ]}
                >
                  <Image
                    resizeMode={"contain"}
                    style={styles.imgDetail}
                    source={{ uri: item.image_url }}
                  />
                  <View style={{ width: "60%" }}>
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textTitle, { marginTop: 0 }]}
                    >
                      NAME
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textSubject]}
                    >
                      {item.name}
                    </Text>
                    <TouchableOpacity
                      disabled={item.condition}
                      onPress={() => {
                        // Associationdata.map((items, idexs) => {
                        //   let itemArr = items.Approbations.filter((i) => {
                        //     return item.competition_id == i.competition_id;
                        //   })[0];
                        //   if (
                        //     itemArr.approbation_status == "Pending" &&
                        //     itemArr.approbation_type == "Final"
                        //   ) {
                        //     setMotype(false);
                        //     onModalShow();
                        //   } else {
                        //     navigation.navigate("Condition", {
                        //       ...item,
                        //       ...itemArr,
                        //     });
                        //   }
                        // });
                        navigation.navigate("Condition", item);
                      }}
                      style={[
                        stylesResponsive.buttomDetail,
                        {
                          backgroundColor: item.condition
                            ? "#AFAFAF"
                            : "#2B6AB1",
                        },
                      ]}
                    >
                      <Text
                        style={[
                          stylesResponsive.textButtonDetail,
                          {
                            backgroundColor: item.condition
                              ? "#AFAFAF"
                              : "#2B6AB1",
                          },
                        ]}
                      >
                        CONDITION
                      </Text>
                    </TouchableOpacity>

                    <TouchableOpacity
                      onPress={() => {
                        conditioncheckApi(item);
                      }}
                      disabled={!(prelim && item.condition)}
                      style={[
                        stylesResponsive.buttomDetail,
                        {
                          backgroundColor: !(prelim && item.condition)
                            ? "#AFAFAF"
                            : "#2B6AB1",
                        },
                      ]}
                    >
                      <Text style={stylesResponsive.textButtonDetail}>
                        PRELIM. FORM
                      </Text>
                    </TouchableOpacity>

                    <TouchableOpacity
                      onPress={() => {
                        Associationdata.map((items, idexs) => {
                          let itemArr = items.Approbations.filter((i) => {
                            return item.competition_id == i.competition_id;
                          })[0];
                          if (
                            itemArr.approbation_status == "Pending" &&
                            itemArr.approbation_type == "Final"
                          ) {
                            setMotype(false);
                            onModalShow();
                          } else {
                            navigation.navigate("FinalEntryUser", {
                              ...item,
                              ...itemArr,
                            });
                          }
                        });
                      }}
                      // disabled={item.final_status == "Pending" ? true : false}
                      disabled={!final}
                      style={[
                        stylesResponsive.buttomDetail,
                        {
                          backgroundColor: !final ? "#AFAFAF" : "#2B6AB1",
                        },
                      ]}
                    >
                      <Text style={stylesResponsive.textButtonDetail}>
                        FINAL FORM
                      </Text>
                    </TouchableOpacity>
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textTitle]}
                    >
                      STATUS
                    </Text>
                    <Text style={[stylesResponsive.textSubject]}>
                      {item.prelim_status === "Open" ||
                      item.final_status === "Open"
                        ? "active"
                        : "inactive"}
                      {/* {item.final_status !== "Open" ? "inactive" : "active"} */}
                    </Text>
                  </View>
                </View>
              );
            }}
          />
        </View>
      </ScrollView>
    </View>
  );
}
